import { render, staticRenderFns } from "./MemberSocialLinks.vue?vue&type=template&id=32ae93ce"
import script from "./MemberSocialLinks.vue?vue&type=script&lang=js"
export * from "./MemberSocialLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports